<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div fxLayout="column" fxLayoutAlign="center center">
  <img src="assets/images/Cookie-settings.svg" alt="" class="nvc-call-media" />
  <div class="nvc-text-align">
    Please provide necessary cookie permission to proceed with video call
  </div>
  <img
    [ngClass]="
      isMobileDevice()
        ? 'nvc-icon-mobile nvc-icon-mobile-mic'
        : isTabDevice()
        ? 'nvc-icon-mic'
        : 'nvc-icon-mic'
    "
    src="assets/icons/cookie.png"
    alt=""
  />
  <div class="nvc-long-text-mobile">
    Seems your cookies are disabled, please enable them in your browser and
    reload the page
  </div>
  <!-- <button
    class="ws-cursor-pointer nvc-border-radius ws-border-none ws-outline-none"
    [ngClass]="
      isMobileDevice()
        ? 'ws-create-btn-mobile'
        : isTabDevice()
        ? 'ws-create-btn-tab'
        : 'ws-create-btn'
    "
    (click)="dialogRef.close({ home: true })"
  >
    Got It
  </button> -->
</div>
